module.exports = __webpack_public_path__ + "static/media/DeactivateUser.7d3df171.png";